export default "<h2>Page not found</h2>\r\n\r\n"